import { render } from "./InterviewSetting.vue?vue&type=template&id=70d97f20&scoped=true"
import script from "./InterviewSetting.vue?vue&type=script&lang=js"
export * from "./InterviewSetting.vue?vue&type=script&lang=js"

import "./InterviewSetting.vue?vue&type=style&index=0&id=70d97f20&scoped=true&lang=css"

import exportComponent from "D:\\projectLinkoffer\\green-lit-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70d97f20"]])

export default __exports__